module.exports = __webpack_public_path__ + "static/media/login-register-forgot.58fcf26c.png";